export default __webpack_public_path__ + "static/media/unionpay-icon.35b08be1.svg";